module.exports = __webpack_public_path__ + "static/media/down-arrow.90f1a2fd.svg";